"use strict";

exports.__esModule = true;
exports.default = executeBound;
var _baseCreate = _interopRequireDefault(require("./_baseCreate.js"));
var _isObject = _interopRequireDefault(require("./isObject.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = (0, _baseCreate.default)(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if ((0, _isObject.default)(result)) return result;
  return self;
}